import React from "react";
import { Rating } from "react-simple-star-rating";
import styled from "styled-components";
import { EmptyStar } from "@/assets/Icons/EmptyStar";
import { FilledStar } from "@/assets/Icons/FilledStar";

interface StyledStarsRatingProps {
  initialRatingValue?: number;
  size?: number;
  isReadonly?: boolean;
  isFractional?: boolean;
  fillColor?: string;
  onClick?: (rate: number) => void;
}

const StyledStarsRating = ({
  initialRatingValue = 0,
  size = 30,
  isReadonly = false,
  isFractional = false,
  onClick,
}: StyledStarsRatingProps) => {
  return (
    <StarsRow>
      <Rating
        onClick={onClick}
        allowFraction={isFractional}
        readonly={isReadonly}
        initialValue={initialRatingValue}
        fillIcon={<FilledStar size={size} />}
        emptyIcon={<EmptyStar size={size} />}
      />
    </StarsRow>
  );
};

const StarsRow = styled.div`
  line-height: 0;
  svg {
    display: inline;
  }
`;

export default StyledStarsRating;
